/* BYROE landing sections: scroll reveal, sticky buy bar, add-to-cart, carousel */
(function () {
  if (window.__tpLanding) return;
  window.__tpLanding = true;
  var design = window.Shopify && window.Shopify.designMode;
  var root = (window.Shopify && window.Shopify.routes && window.Shopify.routes.root) || '/';

  function reveal(scope) {
    var els = (scope || document).querySelectorAll('.tp-reveal:not(.is-in)');
    if (design || !('IntersectionObserver' in window)) {
      els.forEach(function (el) { el.classList.add('is-in'); });
      return;
    }
    var io = new IntersectionObserver(function (entries) {
      entries.forEach(function (e) {
        if (e.isIntersecting) { e.target.classList.add('is-in'); io.unobserve(e.target); }
      });
    }, { rootMargin: '0px 0px -8% 0px' });
    els.forEach(function (el) { io.observe(el); });
  }

  function sticky() {
    var bar = document.querySelector('[data-tp-sticky]');
    var buy = document.querySelector('[data-tp-hero-buy]');
    if (!bar || !buy || !('IntersectionObserver' in window)) return;
    var finals = document.querySelectorAll('[data-tp-final]');
    var heroOut = false, finalIn = false;
    function upd() {
      var on = heroOut && !finalIn;
      bar.classList.toggle('is-on', on);
      bar.setAttribute('aria-hidden', on ? 'false' : 'true');
    }
    new IntersectionObserver(function (e) {
      heroOut = !e[0].isIntersecting && e[0].boundingClientRect.top < 0; upd();
    }).observe(buy);
    finals.forEach(function (f) {
      new IntersectionObserver(function (e) { finalIn = e[0].isIntersecting; upd(); }, { threshold: 0.2 }).observe(f);
    });
  }

  /* Add to cart: same flow as the theme's product form, so the cart drawer opens.
     If anything fails, the form falls back to a normal POST to /cart/add. */
  document.addEventListener('submit', function (e) {
    var form = e.target.closest && e.target.closest('form[data-tp-atc]');
    if (!form || !window.fetch) return;
    e.preventDefault();
    var btn = form.querySelector('[type="submit"]');
    if (btn) { if (btn.getAttribute('aria-busy') === 'true') return; btn.setAttribute('aria-busy', 'true'); }
    var sections = new Set();
    document.documentElement.dispatchEvent(new CustomEvent('cart:prepare-bundled-sections', { bubbles: true, detail: { sections: sections } }));
    var fd = new FormData(form);
    fd.set('sections', Array.from(sections).join(','));
    var theme = window.themeVariables && window.themeVariables.settings;
    fetch(root + 'cart/add.js', { method: 'POST', body: fd, headers: { 'X-Requested-With': 'XMLHttpRequest' } })
      .then(function (res) { return res.json().then(function (json) { return { ok: res.ok, json: json }; }); })
      .then(function (r) {
        if (btn) btn.removeAttribute('aria-busy');
        if (!r.ok) {
          document.dispatchEvent(new CustomEvent('toast:show', { detail: { message: r.json.description || r.json.message || 'Could not add to cart', tone: 'error' } }));
          return;
        }
        if (!theme || theme.cartType === 'page' || !document.querySelector('cart-drawer')) {
          window.location.href = root + 'cart';
          return;
        }
        return fetch(root + 'cart.js').then(function (c) { return c.json(); }).then(function (cart) {
          cart.sections = r.json.sections;
          var items = r.json.items || [r.json];
          form.dispatchEvent(new CustomEvent('variant:add', { bubbles: true, detail: { items: items, cart: cart } }));
          document.documentElement.dispatchEvent(new CustomEvent('cart:change', { bubbles: true, detail: { baseEvent: 'variant:add', cart: cart } }));
        });
      })
      .catch(function () { if (btn) btn.removeAttribute('aria-busy'); form.submit(); });
  });

  /* Carousel (results section): scroll-snap track + arrows + dots + optional autoplay */
  function carousels(scope) {
    (scope || document).querySelectorAll('[data-tp-carousel]:not([data-ready])').forEach(function (el) {
      el.setAttribute('data-ready', '');
      var track = el.querySelector('.tp-car__track');
      var slides = track ? track.children : [];
      if (!track || slides.length < 2) return;
      var dots = el.querySelectorAll('.tp-car__dot');
      var idx = 0, timer = null;
      var delay = parseInt(el.getAttribute('data-autoplay') || '0', 10) * 1000;
      function go(i) {
        idx = (i + slides.length) % slides.length;
        track.scrollTo({ left: slides[idx].offsetLeft - track.offsetLeft, behavior: 'smooth' });
      }
      function mark() {
        var i = Math.round(track.scrollLeft / track.clientWidth);
        idx = Math.max(0, Math.min(slides.length - 1, i));
        dots.forEach(function (d, k) { d.setAttribute('aria-current', k === idx ? 'true' : 'false'); });
        if (cur) cur.textContent = idx + 1;
      }
      function stop() { if (timer) { clearInterval(timer); timer = null; } }
      function start() { if (delay && !design) { stop(); timer = setInterval(function () { go(idx + 1); }, delay); } }
      track.addEventListener('scroll', function () { window.requestAnimationFrame(mark); }, { passive: true });
      el.querySelectorAll('[data-tp-prev]').forEach(function (b) { b.addEventListener('click', function () { stop(); go(idx - 1); }); });
      el.querySelectorAll('[data-tp-next]').forEach(function (b) { b.addEventListener('click', function () { stop(); go(idx + 1); }); });
      var cur = el.querySelector('[data-tp-cur]');
      var firstImg = slides[0].querySelector('img');
      function mid() { if (firstImg && firstImg.offsetHeight) el.style.setProperty('--tp-car-mid', (firstImg.offsetHeight / 2) + 'px'); }
      mid(); window.addEventListener('resize', mid); if (firstImg) firstImg.addEventListener('load', mid);
      /* theme editor: selecting a slide block jumps to it */
      document.addEventListener('shopify:block:select', function (e) {
        var k = Array.prototype.indexOf.call(slides, e.target);
        if (k > -1) { stop(); go(k); }
      });
      dots.forEach(function (d, k) { d.addEventListener('click', function () { stop(); go(k); }); });
      el.addEventListener('pointerenter', stop);
      el.addEventListener('pointerleave', start);
      el.addEventListener('touchstart', stop, { passive: true });
      mark(); start();
    });
  }

  function init() { reveal(); sticky(); carousels(); }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', init); else init();
  document.addEventListener('shopify:section:load', function (e) { reveal(e.target); carousels(e.target); });
})();
